/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/work',
    component: Layout,
    name: 'WorkSys',
    menuid: 171,
    systemtypeid: 6,
    meta: {
      title: 'WorkTitle',
      icon: 'clipboard'
    },
    children: [ 
      {
        path: 'scheduling/index',
        component: () => import('@/views/work/scheduling/list'),
        name: 'SchedulingList',
        menuid: 172,
        systemtypeid: 6,
        meta: {title: 'SchedulingList', icon: 'edit'}
      },  
      {
        path: 'offduty/index',
        component: () => import('@/views/work/offduty/list'),
        name: 'OffdutyList',
        menuid: 173,
        systemtypeid: 6,
        meta: {title: 'OffdutyList', icon: 'guide'}
      },  
      {
        path: 'handsign/index',
        component: () => import('@/views/work/handsign/list'),
        name: 'HandsignList',
        menuid: 174,
        systemtypeid: 6,
        meta: {title: 'HandsignList', icon: 'form'}
      },  
      {
        path: 'plan/index',
        component: () => import('@/views/work/plan/list'),
        name: 'PlanList',
        menuid: 177,
        systemtypeid: 6,
        meta: {title: 'PlanList', icon: 'clipboard'}
      },  
      {
        path: 'report/index',
        component: () => import('@/views/work/report/list'),
        name: 'ReportList',
        menuid: 176,
        systemtypeid: 6,
        meta: {title: 'ReportList', icon: 'excel'}
      },  
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/work.js